export const UsersEndpoints = {
  find: () => {
    return `${process.env.CONTENT_SEARCH_URL}/v1/users/search`
  }
}
